export function HeaderNavItem() {
	return (
		<>
			<ul className="wp-checkout-nav-list">
				<li className="wp-checkout-nav-list-item">
					<a href="#">Home</a>
				</li>
				<li className="wp-checkout-nav-list-item">
					<a href="#">Browse</a>
				</li>
				<li className="wp-checkout-nav-list-item">
					<a href="#">Pricing</a>
				</li>
				<li className="wp-checkout-nav-list-item">
					<a href="#">Docs</a>
				</li>
				<li className="wp-checkout-nav-list-item">
					<a href="#">Blog</a>
				</li>
			</ul>
		</>
	);
}
